<template>
  <div class="form form-invoice">
    <h5>{{ $t("message.contracts.document_cmr") }}</h5>
    <validation
      v-if="document_id != 'new'"
      :action="go_to_error"
      section="cmr"
      :contractId="$route.params.id"
      :item="document_id"
    />
    <br />
    <div class="alert mt-2 alert-success rounded d-flex" v-if="CMR.IsSigned">
      <span style="flex-basis: 50%">
        {{ $t("message.contracts.signed_message_" + CMR.SignatureType) }}
        {{ CMR.SignDate }}<br />
        {{ CMR.SignatureName }}
      </span>
    </div>
    <span
      :class="[
        'bmd-form-group mb-2 d-block form-label-group required',
        $v.CMR.cmr_number.$error ? 'has-danger' : '',
      ]"
    >
      <input
        type="text"
        class="form-control"
        v-model="CMR.cmr_number"
        :placeholder="$t('message.contracts.cmr_number')"
        autocomplete="off"
        style="cursor: auto"
        id="cmr_number"
        :disabled="is_field_readonly"
      />
      <label for="cmr_number" class="form-label-group-label shorter">{{
        $t("message.contracts.cmr_number")
      }}</label>
      <label
        v-if="form_error && !$v.CMR.cmr_number.required"
        class="control-label text-danger d-block"
        >{{ $t("message.errors.required") }}</label
      >
    </span>
    <span
      :class="[
        'bmd-form-group mb-2 d-block form-label-group required',
        $v.CMR.cmr_date.$error ? 'has-danger' : '',
      ]"
    >
      <!-- <b-form-datepicker :locale="locale" v-model="CMR.cmr_date" :placeholder="$t('message.contracts.cmr_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="cmr_date"></b-form-datepicker>
			<label  v-if="CMR.cmr_date!=''"  for="cmr_date" class="form-label-group-label shorter topped">{{$t('message.contracts.cmr_date')}}</label> -->

      <datepicker
        value-type="YYYY-MM-DD"
        format="DD.MM.YYYY"
        @focus="CMR.cmr_date = ' '"
        @blur="
          CMR.cmr_date == ' '
            ? (CMR.cmr_date = '')
            : (CMR.cmr_date = CMR.cmr_date)
        "
        inputClass="form-control"
        v-model="CMR.cmr_date"
        :placeholder="$t('message.contracts.cmr_date')"
        :inputAttr="{ id: 'cmr_date' }"
        :disabled="is_field_readonly"
      />
      <label
        for="cmr_date"
        class="form-label-group-label shorter"
        :class="CMR.cmr_date != '' && CMR.cmr_date != null ? 'topped' : ''"
        >{{ $t("message.contracts.cmr_date") }}</label
      >

      <label
        v-if="form_error && !$v.CMR.cmr_date.required"
        class="control-label text-danger d-block"
        >{{ $t("message.errors.required") }}</label
      >
    </span>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-10">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group required',
                buyer_focused ? 'focused' : '',
                $v.CMR.cmr_sender.value.$error ? 'has-danger' : '',
              ]"
            >
              <v-select-popup
                type="company"
                :placeholder="$t('message.contracts.cmr_sender')"
                v-model="CMR.cmr_sender"
              />

              <!-- <v-select id="cmr_sender" :options="companies" label="display_text" :class="['form-control', typeof CMR.cmr_sender !== 'undefined' && CMR.cmr_sender.value!==''?'vs--selected':'']" @search="fetchContragents"  v-model="CMR.cmr_sender" :placeholder="$t('message.contracts.cmr_sender')" @focus="buyerFocused" @blur="buyerBlurred" :disabled="is_field_readonly"></v-select>	
	                   		<label for="cmr_sender" class="form-label-group-label shorter">{{$t('message.contracts.cmr_sender')}}</label> -->
              <label
                v-if="form_error && !$v.CMR.cmr_sender.value.required"
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
          <div class="col-2">
            <button
              v-if="!is_field_readonly"
              class="btn btn-sm btn-outline-info float-right"
              style="height: 56px; margin-top: 8px"
              @click="addSender"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-10">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group required',
                seller_focused ? 'focused' : '',
                $v.CMR.cmr_recipient.value.$error ? 'has-danger' : '',
              ]"
            >
              <v-select-popup
                type="company"
                :placeholder="$t('message.contracts.cmr_recipient')"
                v-model="CMR.cmr_recipient"
              />
              <!-- <v-select id="cmr_recipient" :options="companies" label="display_text" :class="['form-control', typeof CMR.cmr_recipient !== 'undefined' && CMR.cmr_recipient.value!==''?'vs--selected':'']" @search="fetchContragents"  v-model="CMR.cmr_recipient" :placeholder="$t('message.contracts.cmr_recipient')" @focus="sellerFocused" @blur="sellerBlurred" :disabled="is_field_readonly"></v-select>
		                   	<label for="cmr_recipient" class="form-label-group-label shorter">{{$t('message.contracts.cmr_recipient')}}</label> -->
              <label
                v-if="form_error && !$v.CMR.cmr_recipient.value.required"
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
          <div class="col-2">
            <button
              v-if="!is_field_readonly"
              class="btn btn-sm btn-outline-info float-right"
              style="height: 56px; margin-top: 8px"
              @click="addRecipient"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <span
      :class="[
        'bmd-form-group mb-2 mt-2 d-block form-label-group required',
        customs_focused ? 'focused' : '',
        $v.CMR.custom_code.value.$error ? 'has-danger' : '',
      ]"
    >
      <v-select-popup
        type="customs_office"
        :placeholder="$t('message.contracts.custom_code')"
        v-model="CMR.custom_code"
      />

      <!-- <v-select id="custom_code" :options="customs_offices" label="display_text" :class="['form-control', typeof CMR.custom_code !== 'undefined' && CMR.custom_code.value!==''?'vs--selected':'']" @search="fetchCustomCode"  v-model="CMR.custom_code" :placeholder="$t('message.contracts.custom_code')" @focus="customs_focused=true" @blur="customs_focused=false" :disabled="is_field_readonly"></v-select>
			<label for="custom_code" class="form-label-group-label shorter">{{$t('message.contracts.custom_code')}}</label> -->
      <label
        v-if="form_error && !$v.CMR.custom_code.value.required"
        class="control-label text-danger d-block"
        >{{ $t("message.errors.required") }}</label
      >
    </span>
    <h5>{{ $t("message.contracts.cmr_g_3") }}</h5>
    <!-- <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group required', $v.ContractDeliveryTerms.DeliveryTermsStringCode.$error?'has-danger':'', placeholder_delivery?'placeholderStatus':'', delivery_focused?'focused':'']"> -->
    <code-value
      :label="$t('message.contracts.DeliveryTermsStringCode')"
      :value_placeholder="$t('message.contracts.DeliveryTermsStringCode')"
      :code_placeholder="$t('message.contracts.DeliveryTermsStringCode_code')"
      type="delivery_term"
      v-model="ContractDeliveryTerms.DeliveryTermsStringCode"
      :readonly="is_field_readonly"
    ></code-value>
    <!-- <v-select id="DeliveryTermsStringCode" :options="delivery_terms" label="display_text" :class="['form-control', typeof ContractDeliveryTerms.DeliveryTermsStringCode !== 'undefined' && ContractDeliveryTerms.DeliveryTermsStringCode.value!==''?'vs--selected':'']" @search="fetchDeliveryTerms"  v-model="ContractDeliveryTerms.DeliveryTermsStringCode" :placeholder="$t('message.contracts.DeliveryTermsStringCode')" @focus="deliveryFocused" @blur="deliveryBlurred"></v-select> -->
    <!-- <label for="DeliveryTermsStringCode" class="form-label-group-label shorter">{{$t('message.contracts.conditions')}}</label> -->
    <label
      v-if="
        form_error &&
        !$v.ContractDeliveryTerms.DeliveryTermsStringCode.value.required
      "
      class="control-label text-danger d-block"
      >{{ $t("message.errors.required") }}</label
    >
    <!-- </span> -->
    <translatable>
      <span
        :class="[
          'bmd-form-group mb-2 d-block form-label-group required',
          $v.ContractDeliveryTerms.DeliveryPlace.$error ? 'has-danger' : '',
        ]"
      >
        <input
          type="text"
          class="form-control"
          v-model="ContractDeliveryTerms.DeliveryPlace"
          :placeholder="$t('message.contracts.DeliveryPlace')"
          autocomplete="off"
          style="cursor: auto"
          id="DeliveryPlace"
          :disabled="is_field_readonly"
        />
        <label for="DeliveryPlace" class="form-label-group-label shorter">{{
          $t("message.contracts.DeliveryPlace")
        }}</label>
        <label
          v-if="form_error && !$v.ContractDeliveryTerms.DeliveryPlace.required"
          class="control-label text-danger d-block"
          >{{ $t("message.errors.required") }}</label
        >
      </span>
    </translatable>
    <translatable>
      <span :class="['bmd-form-group mb-2 d-block form-label-group']">
        <input
          type="text"
          class="form-control"
          v-model="ContractDeliveryTerms.TermsDescription"
          :placeholder="$t('message.contracts.TermsDescription')"
          autocomplete="off"
          style="cursor: auto"
          id="TermsDescription"
          :disabled="is_field_readonly"
        />
        <label for="TermsDescription" class="form-label-group-label shorter">{{
          $t("message.contracts.TermsDescription")
        }}</label>
      </span>
    </translatable>
    <h5>{{ $t("message.contracts.cmr_g_4") }}</h5>
    <div class="row">
      <div class="col-12">
        <span
          :class="[
            'bmd-form-group mb-1 d-block  form-label-group required',
            $v.TakingCargoPlace.CountryCode.value.$error ? 'has-danger' : '',
            country_focused ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="country"
            :placeholder="$t('message.contracts.cmr_CountryCode')"
            v-model="TakingCargoPlace.CountryCode"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="invoice_products_OriginCountryCode" :options="countries" label="display_text" :class="['form-control', typeof TakingCargoPlace.CountryCode !== 'undefined' && TakingCargoPlace.CountryCode.value!==''?'vs--selected':'']" @search="fetchCountries" @focus="countryFocus" @blur="countryBlur" v-model="TakingCargoPlace.CountryCode" :placeholder="$t('message.contracts.cmr_CountryCode')" :disabled="is_field_readonly"></v-select>
					 <label for="cmr_CountryCode" class="form-label-group-label shorter">{{$t('message.contracts.cmr_CountryCode')}}</label> -->
          <label
            v-if="form_error && !$v.TakingCargoPlace.CountryCode.value.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <translatable>
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required',
              $v.TakingCargoPlace.City.$error ? 'has-danger' : '',
            ]"
          >
            <input
              type="text"
              class="form-control"
              v-model="TakingCargoPlace.City"
              :placeholder="$t('message.contracts.cmr_City')"
              autocomplete="off"
              style="cursor: auto"
              id="cmr_City"
              :disabled="is_field_readonly"
            />
            <label for="cmr_City" class="form-label-group-label shorter">{{
              $t("message.contracts.cmr_City")
            }}</label>
            <label
              v-if="form_error && !$v.TakingCargoPlace.City.required"
              class="control-label text-danger d-block"
              >{{ $t("message.errors.required") }}</label
            >
          </span>
        </translatable>
      </div>
      <div class="col-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="TakingCargoPlace.PostalCode"
            :placeholder="$t('message.contracts.cmr_PostalCode')"
            autocomplete="off"
            style="cursor: auto"
            id="cmr_PostalCode"
            :disabled="is_field_readonly"
          />
          <label for="cmr_PostalCode" class="form-label-group-label shorter">{{
            $t("message.contracts.cmr_PostalCode")
          }}</label>
        </span>
      </div>
    </div>
    <translatable>
      <span :class="['bmd-form-group mb-2 d-block form-label-group']">
        <input
          type="text"
          class="form-control"
          v-model="TakingCargoPlace.StreetHouse"
          :placeholder="$t('message.contracts.cmr_StreetHouse')"
          autocomplete="off"
          style="cursor: auto"
          id="cmr_StreetHouse"
          :disabled="is_field_readonly"
        />
        <label for="cmr_StreetHouse" class="form-label-group-label shorter">{{
          $t("message.contracts.cmr_StreetHouse")
        }}</label>
      </span>
    </translatable>
    <span
      :class="[
        'bmd-form-group mb-2 d-block form-label-group required',
        $v.TakingCargoPlace.TakingCargoDate.$error ? 'has-danger' : '',
      ]"
    >
      <!-- <b-form-datepicker :locale="locale" v-model="TakingCargoPlace.TakingCargoDate" :placeholder="$t('message.contracts.cmr_TakingCargoDate')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="cmr_date2"></b-form-datepicker>
			<label  v-if="TakingCargoPlace.TakingCargoDate!=''"  for="cmr_TakingCargoDate" class="form-label-group-label shorter topped">{{$t('message.contracts.cmr_TakingCargoDate')}}</label> -->

      <datepicker
        value-type="YYYY-MM-DD"
        format="DD.MM.YYYY"
        @focus="TakingCargoPlace.TakingCargoDate = ' '"
        @blur="
          TakingCargoPlace.TakingCargoDate == ' '
            ? (TakingCargoPlace.TakingCargoDate = '')
            : (TakingCargoPlace.TakingCargoDate =
                TakingCargoPlace.TakingCargoDate)
        "
        inputClass="form-control"
        v-model="TakingCargoPlace.TakingCargoDate"
        :placeholder="$t('message.contracts.cmr_TakingCargoDate')"
        :inputAttr="{ id: 'cmr_TakingCargoDate' }"
        :disabled="is_field_readonly"
      />
      <label
        for="cmr_TakingCargoDate"
        class="form-label-group-label shorter"
        :class="
          TakingCargoPlace.TakingCargoDate != '' &&
          TakingCargoPlace.TakingCargoDate != null
            ? 'topped'
            : ''
        "
        >{{ $t("message.contracts.cmr_TakingCargoDate") }}</label
      >

      <label
        v-if="form_error && !$v.TakingCargoPlace.TakingCargoDate.required"
        class="control-label text-danger d-block"
        >{{ $t("message.errors.required") }}</label
      >
    </span>

    <h5>{{ $t("message.contracts.cmr_products") }}</h5>
    <div class="input-group mb-3" style="width: 300px">
      <input
        class="form-control"
        type="text"
        v-model="looking_for_product_number"
        style="height: 32px"
        :placeholder="$t('message.contracts.search_by_number')"
      />
      <div class="input-group-append">
        <button
          @click="lookForProductByNumber"
          class="btn btn-sm btn-outline-success"
        >
          {{ $t("message.contracts.search_by_number_button") }}
        </button>
      </div>
    </div>
    <b-table
      responsive
      striped
      hover
      :items="CMRGoods"
      :tbody-tr-class="rowClass"
      :fields="product_fields"
      :current-page="product_page"
      :per-page="3"
    >
      <template v-slot:cell(index)="data">
        <strong>{{ data.index + 1 }}</strong>
      </template>
      <template v-slot:cell(GoodMarking)="data">
        <strong>{{ data.value }}</strong>
      </template>
      <template v-slot:cell(attis_cg_quantity)="data">
        <strong
          >{{ data.value }}
          {{ data.item.attis_cg_measures.display_text }}</strong
        >
      </template>
      <template v-slot:cell(attis_cg_price)="data">
        <strong
          >{{ addThousandsSeparator(data.value, ",") }}
          {{ attis_contracts.attis_contract_currency.display_text }}</strong
        >
      </template>

      <template v-slot:cell(remove)="data">
        <button
          class="btn btn-sm btn-link text-info"
          @click="editProduct(product_page * 3 + data.index)"
        >
          <i class="fa fa-edit"></i></button
        ><button
          v-if="!is_field_readonly"
          class="btn btn-sm btn-link text-danger"
          @click="removeProduct(data.index)"
        >
          <i class="fa fa-times"></i>
        </button>
      </template>
    </b-table>
    <div class="alert alert-danger" v-if="products_marking_error">
      {{ $t("message.contracts.cmr_products_GoodsMarking") }}
      {{ $t("message.errors.required") }}
    </div>
    <div class="d-flex justify-content-center">
      <b-pagination
        v-if="CMRGoods.length / 3 > 1"
        v-model="product_page"
        :total-rows="CMRGoods.length"
        :per-page="3"
      ></b-pagination>
    </div>
    <transition name="slide">
      <div
        v-if="add_product || edit_product"
        class="add-product-block alert-success-"
        style="margin: 0 -1.5em"
      >
        <span
          :class="[
            'bmd-form-group mb-1 d-block  form-label-group required',
            $v.CMRGood.GoodsDescription.$error ? 'has-danger' : '',
          ]"
        >
          <input
            type="text"
            class="form-control"
            v-model="CMRGood.GoodMarking"
            :placeholder="$t('message.contracts.cmr_products_GoodsMarking')"
            autocomplete="off"
            style="cursor: auto"
            id="cmr_products_GoodsMarking"
            :disabled="is_field_readonly"
          />
          <label
            for="cmr_products_GoodsMarking"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.cmr_products_GoodsMarking") }}</label
          >
          <label
            v-if="product_error && !$v.CMRGood.GoodMarking.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <div class="row">
          <div class="col-md-12">
            <span
              :class="[
                'bmd-form-group mb-1 d-block  form-label-group',
                tnved_focused ? 'focused' : '',
              ]"
            >
              <tnved
                :placeholder="
                  $t('message.contracts.cmr_products_GoodsNomenclatureCode')
                "
                :placeholder_name="$t('message.tnved_name')"
                :placeholder_code="$t('message.tnved_code')"
                v-model="CMRGood.GoodsNomenclatureCode"
                :disabled="is_field_readonly"
              ></tnved>
              <!-- <v-select id="cmr_products_GoodsNomenclatureCode" :options="tnveds" label="display_text" :class="['form-control', typeof CMRGood.GoodsNomenclatureCode !== 'undefined' && CMRGood.GoodsNomenclatureCode.value!==''?'vs--selected':'']" @search="fetchTNVED"  v-model="CMRGood.GoodsNomenclatureCode" :placeholder="$t('message.contracts.cmr_products_GoodsNomenclatureCode')" @focus="tnvedFocused" @blur="tnvedBlurred"></v-select> -->
              <!-- <label for="cmr_products_GoodsNomenclatureCode" class="form-label-group-label shorter">{{$t('message.contracts.cmr_products_GoodsNomenclatureCode')}}</label> -->
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <translatable>
              <span
                :class="[
                  'bmd-form-group mb-1 d-block  form-label-group required',
                  $v.CMRGood.GoodsDescription.$error ? 'has-danger' : '',
                ]"
              >
                <textarea
                  id="cmr_products_GoodsDescription"
                  :options="tnveds"
                  label="display_text"
                  :class="['form-control']"
                  v-model="CMRGood.GoodsDescription"
                  :placeholder="
                    $t('message.contracts.cmr_products_GoodsDescription') + '*'
                  "
                  :disabled="is_field_readonly"
                ></textarea>
                <label
                  v-if="product_error && !$v.CMRGood.GoodsDescription.required"
                  class="control-label text-danger d-block"
                  >{{ $t("message.errors.required") }}</label
                >
              </span>
            </translatable>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="number"
                id="cmr_products_GoodsQuantity"
                label="display_text"
                :class="['form-control']"
                v-model="CMRGood.GoodsQuantity"
                :placeholder="
                  $t('message.contracts.cmr_products_GoodsQuantity')
                "
                :disabled="is_field_readonly"
              />
              <label
                for="cmr_products_GoodsQuantity"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.cmr_products_GoodsQuantity") }}</label
              >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block']">
              <cleave
                id="cmr_goods_bruto_weight_quantity"
                v-model="CMRGood.GrossWeightQuantity"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="
                  $t('message.contracts.cmr_products_GrossWeightQuantity')
                "
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block']">
              <cleave
                id="cmr_goods_neto_weight_quantity"
                v-model="CMRGood.VolumeQuantity"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="
                  $t('message.contracts.cmr_products_VolumeQuantity')
                "
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
            </span>
          </div>
        </div>
        <h5 style="color: black">{{ $t("message.contracts.cmr_places") }}</h5>
        <b-table
          responsive
          striped
          hover
          :items="CMRGood.CMRPlaces"
          :fields="places_fields"
        >
          <!-- <template #cell(action)="data">
            </template> -->
          <template #cell(PackagingTypeCode)="data">
            {{ display_value_text(data.value) }}
          </template>
          <template #cell(number)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(remove)="data">
            <button
              class="btn btn-sm btn-link text-info"
              @click="editPlace(data.index)"
            >
              <i class="fa fa-edit"></i></button
            ><button
              v-if="!is_field_readonly"
              class="btn btn-sm btn-link text-danger"
              @click="removePlace(data.index)"
            >
              <i class="fa fa-times"></i>
            </button>
          </template>
          <!-- <template #cell(number)="data">
                            {{data.index+1}}
            </template> -->
        </b-table>
        <transition name="placesSlide">
          <div
            v-if="add_place || edit_place"
            class="add-product-block alert-success"
            style="margin: 0 -1.5em"
          >
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                packing_code_focused ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="packaging"
                :placeholder="$t('message.contracts.cmr_placesform_type_code')"
                v-model="CMRPlace.PackagingTypeCode"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="packaging_typecode" :options="packagings" label="display_text" @search="fetchPackagings"  :class="['form-control', typeof CMRPlace.PackagingTypeCode.value !== 'undefined' && CMRPlace.PackagingTypeCode.value!==''?'vs--selected':'']" v-model="CMRPlace.PackagingTypeCode" :placeholder="$t('message.contracts.cmr_placesform_type_code')" @focus="packingCodeFocused" @blur="packingCodeBlurred" :disabled="is_field_readonly">
                	</v-select>	
                	<label for="packaging_typecode" class="form-label-group-label shorter">{{$t('message.contracts.cmr_placesform_type_code')}}</label> -->
            </span>
            <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
              <label
                for="places_count"
                :class="[
                  'form-label-group-label shorter',
                  CMRPlace.PlacesCount != '' ? 'high' : '',
                ]"
                >{{
                  $t("message.contracts.cmr_placesform_places_count")
                }}</label
              >
              <cleave
                id="places_count"
                v-model="CMRPlace.PlacesCount"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="
                  $t('message.contracts.cmr_placesform_places_count')
                "
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
            </span>
            <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
              <textarea
                maxlength="255"
                type="text"
                id="places_description"
                label="display_text"
                :class="['form-control']"
                v-model="CMRPlace.Description"
                :placeholder="
                  $t('message.contracts.cmr_placesform_places_description')
                "
                :disabled="is_field_readonly"
              ></textarea>
              <label
                for="places_description"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.cmr_placesform_places_description")
                }}</label
              >
            </span>
            <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
              <label
                for="places_part_count"
                :class="[
                  'form-label-group-label shorter',
                  CMRPlace.PlacesPartCount != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.cmr_placesform_part_count") }}</label
              >
              <cleave
                id="places_part_count"
                v-model="CMRPlace.PlacesPartCount"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="$t('message.contracts.cmr_placesform_part_count')"
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
            </span>
            <div v-if="add_place">
              <button
                id="cmr_goods_add_place_btn"
                class="btn btn-sm btn-success"
                @click="addPlace()"
                v-if="add_place && !is_field_readonly"
              >
                {{ $t("message.contracts.add_place") }}
              </button>
              <button
                class="btn btn-sm btn-danger btn-outline-danger float-right"
                @click="hideAddPlace()"
              >
                {{ $t("message.cancel") }}
              </button>
            </div>
            <div v-if="edit_place">
              <button
                class="btn btn-sm btn-success"
                @click="savePlace()"
                v-if="edit_place && !is_field_readonly"
              >
                {{ $t("message.contracts.save_place") }}
              </button>
              <button
                class="btn btn-sm btn-danger btn-outline-danger float-right"
                @click="hideEditPlace()"
              >
                {{ $t("message.cancel") }}
              </button>
            </div>
          </div>
        </transition>
        <button
          id="cmr_goods_show_place_form_btn"
          class="btn btn-sm btn-outline-success"
          @click="showAddPlace()"
          v-if="!add_place && !is_field_readonly"
        >
          {{ $t("message.contracts.add_place") }}
        </button>
        <div v-if="add_product" class="pt-3">
          <button
            id="cmr-add-product-btn"
            class="btn btn-sm btn-success"
            @click="addProduct()"
            v-if="add_product && !is_field_readonly"
          >
            {{ $t("message.contracts.add_product") }}
          </button>
          <button
            class="btn btn-sm btn-danger btn-outline-danger float-right"
            @click="hideAddProduct()"
          >
            {{ $t("message.cancel") }}
          </button>
        </div>
        <div v-if="edit_product">
          <button
            class="btn btn-sm btn-success"
            @click="saveProduct()"
            v-if="edit_product && !is_field_readonly"
          >
            {{ $t("message.contracts.save_product") }}
          </button>
          <button
            class="btn btn-sm btn-danger btn-outline-danger float-right"
            @click="hideEditProduct()"
          >
            {{ $t("message.cancel") }}
          </button>
        </div>
      </div>
    </transition>
    <button
      id="cmr-add-product-form-btn"
      class="btn btn-sm btn-success btn-outline-success mb-3"
      @click="showAddProduct()"
      v-if="!add_product && !is_field_readonly"
    >
      {{ $t("message.contracts.add_product") }}
    </button>
    <div class="form-group" v-if="!add_product && !is_field_readonly">
      <label for="excel-goods-import">{{
        $t("message.contracts.excel_import_gooods_label")
      }}</label>
      <input
        type="file"
        id="excel-goods-import"
        :disabled="files_loading"
        class="form-control"
        @change="importGoodsExcel($event, index)"
      />
    </div>
    <br /><br />
    <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
      <label
        for="GoodsCost"
        :class="[
          'form-label-group-label shorter',
          CMR.GoodsCost != '' ? 'high' : '',
        ]"
        >{{ $t("message.contracts.cmr_GoodsCost") }}</label
      >
      <cleave
        id="GoodsCost"
        v-model="CMR.GoodsCost"
        :options="cleaveWeight"
        class="form-control"
        :placeholder="$t('message.contracts.cmr_GoodsCost')"
        autocomplete="off"
        style="cursor: auto"
        :disabled="is_field_readonly"
      ></cleave>
    </span>

    <translatable>
      <span :class="['bmd-form-group mb-2 d-block form-label-group']">
        <input
          type="text"
          class="form-control"
          v-model="ConsigneeCustoms.WarehouseName"
          :placeholder="$t('message.contracts.cmr_WarehouseName')"
          autocomplete="off"
          style="cursor: auto"
          id="cmr_WarehouseName"
          :disabled="is_field_readonly"
        />
        <label for="cmr_WarehouseName" class="form-label-group-label shorter">{{
          $t("message.contracts.cmr_WarehouseName")
        }}</label>
      </span>
    </translatable>

    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-10">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                buyer2_focused ? 'focused' : '',
              ]"
            >
              <!--<v-select id="cmr_courier" :options="companies" label="display_text" :class="['form-control', typeof CMR.cmr_courier !== 'undefined' && CMR.cmr_courier.value!==''?'vs--selected':'']" @search="fetchContragents"  v-model="CMR.cmr_courier" :placeholder="$t('message.contracts.cmr_courier')" @focus="buyer2Focused" @blur="buyer2Blurred"></v-select>	
	                   		<label for="cmr_courier" class="form-label-group-label shorter">{{$t('message.contracts.cmr_courier')}}</label>-->
              <v-select-popup
                type="company"
                v-model="CMR.cmr_courier"
                :placeholder="$t('message.contracts.cmr_courier')"
                :readonly="is_field_readonly"
              />
            </span>
          </div>
          <div class="col-2">
            <button
              v-if="!is_field_readonly"
              class="btn btn-sm btn-outline-info float-right"
              style="height: 56px; margin-top: 8px"
              @click="addCourier"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-10">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                seller2_focused ? 'focused' : '',
              ]"
            >
              <!--<v-select id="cmr_courier_next" :options="companies" label="display_text" :class="['form-control', typeof CMR.cmr_courier_next !== 'undefined' && CMR.cmr_courier_next.value!==''?'vs--selected':'']" @search="fetchContragents"  v-model="CMR.cmr_courier_next" :placeholder="$t('message.contracts.cmr_courier_next')" @focus="seller2Focused" @blur="seller2Blurred"></v-select>
		                   	<label for="cmr_courier_next" class="form-label-group-label shorter">{{$t('message.contracts.cmr_courier_next')}}</label>-->
              <v-select-popup
                type="company"
                v-model="CMR.cmr_courier_next"
                :placeholder="$t('message.contracts.cmr_courier_next')"
                :readonly="is_field_readonly"
              />
            </span>
          </div>
          <div class="col-2">
            <button
              v-if="!is_field_readonly"
              class="btn btn-sm btn-outline-info float-right"
              style="height: 56px; margin-top: 8px"
              @click="addCourierNext"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <translatable>
          <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
            <textarea
              maxlength="250"
              id="courier_notes"
              label="display_text"
              :class="['form-control']"
              v-model="CMR.courier_notes"
              :placeholder="$t('message.contracts.courier_notes')"
              :disabled="is_field_readonly"
            ></textarea>
            <label for="courier_notes" class="form-label-group-label shorter">{{
              $t("message.contracts.courier_notes")
            }}</label>
          </span>
        </translatable>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <span
          :class="[
            'bmd-form-group mb-2 d-block form-label-group required',
            $v.CMR.cmr_track.$error ? 'has-danger' : '',
          ]"
        >
          <input
            type="text"
            class="form-control"
            v-model="CMR.cmr_track"
            :placeholder="$t('message.contracts.cmr_track')"
            autocomplete="off"
            style="cursor: auto"
            id="cmr_track"
            :disabled="is_field_readonly"
          />
          <label for="cmr_track" class="form-label-group-label shorter">{{
            $t("message.contracts.cmr_track")
          }}</label>
          <label
            v-if="form_error && !$v.CMR.cmr_track.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
      </div>
      <div class="col-6">
        <span
          :class="[
            'bmd-form-group mb-2 d-block form-label-group  required',
            $v.CMR.cmr_trailer.$error ? 'has-danger' : '',
          ]"
        >
          <input
            maxlength="20"
            type="text"
            class="form-control"
            v-model="CMR.cmr_trailer"
            :placeholder="$t('message.contracts.cmr_trailer')"
            autocomplete="off"
            style="cursor: auto"
            id="cmr_trailer"
            :disabled="is_field_readonly"
          />
          <label for="cmr_trailer" class="form-label-group-label shorter">{{
            $t("message.contracts.cmr_trailer")
          }}</label>
          <label
            v-if="form_error && !$v.CMR.cmr_trailer.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
      </div>
      <div class="col-12">
        <v-select-popup
          type="country"
          v-model="CMR.cmr_track_reg_country_name"
          :placeholder="$t('message.contracts.cmr_track_reg_country_name')"
          :readonly="is_field_readonly"
        />

        <!-- <span :class="['bmd-form-group mb-2 d-block form-label-group  required', $v.CMR.cmr_trailer.$error?'has-danger':'' ]">
					<input type="text" class="form-control" v-model="CMR.cmr_trailer" :placeholder="$t('message.contracts.cmr_trailer')" autocomplete="off" style="cursor: auto;" id="cmr_trailer">
					<label for="cmr_trailer" class="form-label-group-label shorter">{{$t('message.contracts.cmr_trailer')}}</label>
					<label v-if="form_error && !$v.CMR.cmr_trailer.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label>
				</span> -->
      </div>
    </div>
    <h5>{{ $t("message.contracts.cmr_docs") }}</h5>
    <b-table :items="CMR_docs" :fields="CMR_docs_fields">
      <template v-slot:cell(DocumentDate)="data">
        {{ momentum(data.value) }}
      </template>
    </b-table>
    <b-modal
      id="modal-add-sender"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.add_sender')"
      button-size="lg"
    >
      <buyer-seller-form type="sender"></buyer-seller-form>
    </b-modal>
    <b-modal
      id="modal-add-recipient"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.add_recipient')"
      button-size="lg"
    >
      <buyer-seller-form type="recipient"></buyer-seller-form>
    </b-modal>
    <b-modal
      id="modal-add-courier"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.add_courier')"
      button-size="lg"
    >
      <buyer-seller-form type="courier"></buyer-seller-form>
    </b-modal>
    <b-modal
      id="modal-add-courier-next"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.add_courier_next')"
      button-size="lg"
    >
      <buyer-seller-form type="courier_next"></buyer-seller-form>
    </b-modal>
    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px"
    >
      <button
        v-if="!is_field_readonly"
        class="btn btn-outline-success btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="buttons_loading"
      >
        {{
          $t(
            is_new
              ? "message.contracts.document_create"
              : "message.contracts.document_save",
          )
        }}&nbsp;&nbsp;
        <div
          class="loading loading-button"
          v-if="loading"
          style="
            border-top-width: 2px;
            border-top-color: #4caf50;
            top: 30px;
            right: -93px;
          "
        ></div>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a
          id="create-cmr-button"
          class="dropdown-item"
          style="color: #4caf50"
          @click="saveDocument()"
          :disabled="buttons_loading"
          >{{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}</a
        >
        <a
          class="dropdown-item"
          style="color: #4caf50"
          v-if="!is_new"
          @click="submit_and_sign_dialog()"
          :disabled="buttons_loading"
          >{{ $t("message.contracts.submit_and_sign_button") }}</a
        >
      </div>
      <!--<button class="btn btn-success float-left" @click="saveDocument()" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button>
			<button v-if="!is_new" class="btn btn-success float-left" @click="submit_and_sign_dialog()" :disabled=buttons_loading>{{$t('message.contracts.submit_and_sign_button')}}</button>-->
    </div>

    <b-modal
      id="modal-select-ecp-type-cmr"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-outline-success btn-round"
          @click="signDocument()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-success btn-round"
          @click="sign_with_code_phase2()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
import moment from "moment";
export default {
  props: ["goods", "contract_details", "document_id", "document", "is_new"],
  data() {
    return {
      products_marking_error: false,
      loading: false,
      looking_for_product_number: "",
      product_page: 0,
      files_loading: false,
      show_code_sign_type: false,
      sign_with_code_code: "",
      buttons_loading: false,
      customs_focused: false,
      add_product: false,
      add_place: false,
      edit_product: false,
      edit_place: false,
      place_currently_editing: false,
      place_error: false,
      currently_editing: false,
      form_error: false,
      product_error: false,
      currency_focused: false,
      placeholder_currency: false,
      buyer_focused: false,
      packing_code_focused: false,
      seller_focused: false,
      buyer2_focused: false,
      seller2_focused: false,
      tnved_focused: false,
      placeholder_tnved: false,
      placeholder_measure: false,
      measure_focused: false,
      placeholder_delivery: false,
      delivery_focused: false,
      country_focused: false,
      currencies: [],
      measures: [],
      companies: [],
      countries: [],
      tnveds: [],
      delivery_terms: [],
      packagings: [],
      percent_focused: false,
      discount_focused: false,

      cleavePQTY: {
        numeral: false,
        numericOnly: true,
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [8],
      },
      cleaveWeight: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },
      cleavePrice: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [20],
        numeralDecimalScale: 2,
      },

      CMR: {
        cmr_number: "",
        cmr_date: "",
        cmr_sender: { value: "" },
        cmr_recipient: { value: "" },
        cmr_courier: { display_text: "", value: "" },
        cmr_courier_next: { display_text: "", value: "" },
        cmr_track: "",
        cmr_trailer: "",
        custom_code: { value: "" },
        courier_notes: "",
        GoodsCost: "",
        cmr_track_reg_country_name: { value: "", display_text: "" },
        SignDate: "",
        IsSigned: false,
        SignatureName: "",
        SignatureType: "",
      },
      CMR_docs: [],

      ContractDeliveryTerms: {
        DeliveryPlace: "",
        DeliveryTermsStringCode: { display_text: "", value: "" },
        TermsDescription: "",
      },

      TakingCargoPlace: {
        CountryCode: { display_text: "", value: "" },
        City: "",
        StreetHouse: "",
        PostalCode: "",
        TakingCargoDate: "",
      },

      EnclosedDocument: {
        PrDocumentName: "",
        PrDocumentNumber: "",
        PrDocumentDate: "",
      },
      CMRGoods: [],
      CMRGood: {
        GoodsMarking: "",
        GoodsQuantity: "",
        GoodsDescription: "",
        GoodsNomenclatureCode: { display_text: "", value: "" },
        GrossWeightQuantity: "",
        VolumeQuantity: "",
        CMRPlaces: [],
      },
      CMRPlace: {
        PackagingTypeCode: { value: "", display_text: "" },
        PlacesCount: "",
        Description: "",
        PlacesPartCount: "",
      },

      ConsigneeCustoms: {
        WarehouseName: "",
      },
      places_fields: [
        {
          key: "number",
          label: this.$t("message.contracts.packaging_number_pp"),
        },
        {
          key: "PackagingTypeCode",
          label: this.$t("message.contracts.cmr_places_typecode"),
        },
        {
          key: "PlacesCount",
          label: this.$t("message.contracts.cmr_places_count"),
        },
        {
          key: "remove",
          label: "",
        },
      ],
      CMR_docs_fields: [
        {
          key: "DocType",
          label: this.$t("message.contracts.cmr_doc_type"),
        },
        {
          key: "DocumentNumber",
          label: this.$t("message.contracts.cmr_doc_number"),
        },
        {
          key: "DocumentDate",
          label: this.$t("message.contracts.cmr_doc_date"),
        },
      ],
      customs_offices: [],
      product_fields: [
        {
          key: "good_no",
          label: this.$t("message.contracts.product_number"),
          sortable: false,
        },
        {
          key: "GoodMarking",
          label: this.$t("message.contracts.cmr_products_GoodsMarking"),
          sortable: false,
        },
        {
          key: "GoodsQuantity",
          label: this.$t("message.contracts.cmr_products_GoodsQuantity"),
          sortable: false,
        },
        {
          key: "GoodsDescription",
          label: this.$t("message.contracts.cmr_products_GoodsDescription"),
          sortable: false,
        },
        {
          key: "GrossWeightQuantity",
          label: this.$t("message.contracts.cmr_products_GrossWeightQuantity"),
          sortable: false,
        },
        {
          key: "VolumeQuantity",
          label: this.$t("message.contracts.cmr_products_VolumeQuantity"),
          sortable: false,
        },
        {
          key: "remove",
          label: "",
        },
      ],
    };
  },
  methods: {
    /**
     * determines if the row should be highlighted
     */
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (parseInt(item.good_no) === parseInt(this.looking_for_product_number))
        return "table-success";
    },
    /**
     * looks for product in the grid by its guid
     */
    lookForProductByNumber() {
      let index =
        this.CMRGoods.findIndex(
          (good) =>
            parseInt(good.good_no) == parseInt(this.looking_for_product_number),
        ) + 1;
      if (!index) index = this.looking_for_product_number;

      const page = Math.ceil(index / 3);
      this.product_page = page;
    },
    /**
     * finds absolute position of the element
     */
    findPos(obj) {
      var curleft = 0;
      var curtop = 0;

      if (obj.offsetParent) {
        do {
          curleft += obj.offsetLeft;
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));

        return { X: curleft, Y: curtop };
      }
    },
    /**
     * Navigates user to the field with error
     */
    go_to_error(error) {
      // document.querySelector('#products-table').classList.remove('error')
      // this.show_banks_error = false
      // this.show_founder_error  = false
      // switch(error.Subsection){
      // 	case 'Invoice':
      console.log("tikrinam tipa ir id");
      console.log(error.Subsection + " " + error.Id + " " + this.document_id);
      if (error.Subsection == "CMR" && error.Id == this.document_id) {
        switch (error.Value) {
          case "CMRGoods.GoodsPrice <> InvoiceGoods.Price":
            var element = document.querySelector("#GoodsCost");
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
        }
      } else {
        setTimeout(() => {
          error.closeFie = true;
          this.$root.$emit("process_contract_error", error);
        }, 500);
      }
    },
    /**
     * format date
     */
    momentum(date) {
      return moment(date).format("DD.MM.Y");
    },
    /**
     * get contract XML and sends it to backend along with token from e-mail to sign data
     * after signing it gets the signature code and sends it back to the backend
     * to store signature in document
     */
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        axios
          .get(window.base + "/document/LoadCMRXML?doc_id=" + this.document_id)
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.document_id);
                fd.append("signature", response.data);
                axios
                  .post(window.base + "/document/AddDocumentSignature", fd)
                  .then(() => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-cmr");
                  })
                  .catch((e) => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-cmr");
                  });
              });
          });
      }
    },
    /**
     * Sends request to backend to send a code to sign a document without ECP
     */
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    /**
     * Displays a dialog to select which method of electronic signature fits user the best.
     */
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type-cmr");
    },
    /**
     * Initializes electorinc signature for the document.
     * Gets XML from backend.
     * Signs with NCA Layer.
     * Sends signature back to backend to store for future comparison.
     */
    signDocument() {
      this.loading = true;
      axios
        .get(window.base + "/document/LoadCMRXML?doc_id=" + this.document_id)
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;

                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      let name = response.data.cert_name;
                      fd.append("document_id", this.document_id);
                      fd.append("contract_id", this.document_id);
                      fd.append("signature_name", name);
                      fd.append("signature", value);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/document/AddDocumentSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.document_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-cmr");
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.document_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-cmr");
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.document_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                // var fd = new FormData;
                // fd.append('contract_id', this.document_id)
                // fd.append('signature', value)
                // axios.post(window.base + '/document/AddDocumentSignature', fd).then(()=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'success',
                // 		text: this.$root.$t('message.message.document_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-cmr')
                // }).catch(e=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'error',
                // 		text: this.$root.$t('message.message.document_not_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-cmr')
                // })
                window.webSocket.close();
                // window.webSocket.removeEventListener('message', {})
              }
            }
          };
        });
    },
    findTNVED(code, index) {
      axios
        .get(
          window.base +
            "/library/tnved?code=" +
            code +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          if (typeof response.data[0] !== "undefined")
            this.$set(
              this.CMRGoods[index],
              "GoodsNomenclatureCode",
              response.data[0],
            );
          // this.$set(this.attis_contract_goods[index], 'attis_cg_TNVED', response.data[0])
        });
    },
    findDeliveryTerm(code) {
      axios
        .get(
          window.base +
            "/library/delivery_term?code=" +
            code +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          if (typeof response.data[0] !== "undefined")
            this.$set(
              this.ContractDeliveryTerms,
              "DeliveryTermsStringCode",
              response.data[0],
            );
          // this.$set(this.attis_contract_goods[index], 'attis_cg_TNVED', response.data[0])
        });
    },
    fetchCustomCode(search) {
      this.getLibrary("customs_office", search, 10000);
    },
    fetchDeliveryTerms(search, loading) {
      this.getLibrary("delivery_term", search, 10000);
    },
    addCourier() {
      this.$bvModal.show("modal-add-courier");
    },
    addCourierNext() {
      this.$bvModal.show("modal-add-courier-next");
    },
    addSender() {
      this.$bvModal.show("modal-add-sender");
    },
    addRecipient() {
      this.$bvModal.show("modal-add-recipient");
    },
    findLibValueProduct(lib, value, field, index) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&qty=10000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (item.value == value) {
                this.$set(this.CMRGoods[index], field, item);
              }
            });
          });
      }
    },
    findLibValue(lib, value, field) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=10000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (item.value == value) {
                this.$set(this.Invoice, field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value == value) this.$set(this.Invoice, field, item);
        });
      }
    },
    saveProduct() {
      // this.$v.$touch()
      // console.log(this.$v.CMRGood)
      if (this.$v.CMRGood.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          if ($(".has-danger").length > 0)
            $("html,body").animate(
              { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
              1000,
            );
        }, 100);
      } else {
        this.product_error = false;
        this.hideEditProduct();
      }
    },
    hideEditProduct() {
      this.CMRGood = {
        GoodsMarking: "",
        GoodsQuantity: "",
        GoodsDescription: "",
        GoodsNomenclatureCode: { display_text: "", value: "" },
        GrossWeightQuantity: "",
        VolumeQuantity: "",
        CMRPlaces: [],
      };
      this.edit_product = false;
    },
    editProduct(index) {
      this.edit_product = true;
      this.CMRGood = this.CMRGoods[index];
      this.currently_editing = index;
    },
    savePlace() {
      //if (this.$v.CMRPlace.$invalid) {
      // this.place_error = true
      // setTimeout(()=>{
      // 	if($('.has-danger').length>0)
      // 	$('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
      // }, 100)

      //} else {
      this.place_error = false;
      this.hideEditPlace();
      //}
    },
    hideEditPlace() {
      this.CMRPlace = {
        PackagingTypeCode: { value: "", display_text: "" },
        PlacesCount: "",
        Description: "",
        PlacesPartCount: "",
      };
      this.edit_place = false;
    },
    editPlace(index) {
      this.edit_place = true;
      this.CMRPlace = this.CMRGood.CMRPlaces[index];
      this.place_currently_editing = index;
    },
    removePlace(index) {
      this.CMRGood.CMRPlaces.splice(index, 1);
    },
    addPlace() {
      // this.$v.$touch()
      // if (this.$v.CMRGood.$invalid) {
      // 	this.product_error = true
      // 	setTimeout(()=>{
      // 		if($('.has-danger').length>0)
      // 		$('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
      // 	}, 100)

      // } else {
      this.place_error = false;
      console.log("checkinu");
      console.log(this.CMRGood);
      console.log(this.CMRPlace);
      this.CMRGood.CMRPlaces.push({
        PackagingTypeCode: this.CMRPlace.PackagingTypeCode,
        PlacesCount: this.CMRPlace.PlacesCount,
        Description: this.CMRPlace.Description,
        PlacesPartCount: this.CMRPlace.PlacesPartCount,
      });
      this.hideAddPlace();

      // }
    },
    removeProduct(index) {
      this.CMRGoods.splice(index, 1);
    },
    addProduct() {
      // this.$v.$touch()
      if (this.$v.CMRGood.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          if ($(".has-danger").length > 0)
            $("html,body").animate(
              { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
              1000,
            );
        }, 100);
      } else {
        this.product_error = false;
        this.CMRGoods.push({
          good_no: this.CMRGoods.length + 1,
          GoodMarking: this.CMRGood.GoodMarking,
          GoodsNomenclatureCode: this.CMRGood.GoodsNomenclatureCode,
          GoodsDescription: this.CMRGood.GoodsDescription,
          GoodsQuantity: this.CMRGood.GoodsQuantity,
          GrossWeightQuantity: this.CMRGood.GrossWeightQuantity,
          VolumeQuantity: this.CMRGood.VolumeQuantity,
          CMRPlaces: this.CMRGood.CMRPlaces,
        });
        this.hideAddProduct();
      }
    },
    showAddProduct() {
      this.add_product = true;
    },
    hideAddProduct() {
      this.add_product = false;
      this.CMRGood = {
        GoodsMarking: "",
        GoodsQuantity: "",
        GoodsDescription: "",
        GoodsNomenclatureCode: { display_text: "", value: "" },
        GrossWeightQuantity: "",
        VolumeQuantity: "",
        CMRPlaces: [],
      };
    },
    showAddPlace() {
      this.add_place = true;
    },
    hideAddPlace() {
      this.add_place = false;
      this.CMRPlace = {
        PackagingTypeCode: { value: "", display_text: "" },
        PlacesCount: "",
        Description: "",
        PlacesPartCount: "",
      };
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    display_value_text(value) {
      console.log(value);
      return value.value + " - " + value.display_text;
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    fetchTNVED(search, loading) {
      this.getLibrary("tnved", search, 10000);
    },
    fetchMeasures(search, loading) {
      this.getLibrary("measure", search, 10000);
    },
    fetchCurrencies() {
      this.getLibrary("currency", "", 10000);
    },
    fetchContragents(search, loading) {
      this.getLibrary("company", search, 10000);
    },
    fetchPackagings(search, loading) {
      this.getLibrary("packaging", search, 100);
    },
    currenciesFocused() {
      this.currency_focused = true;
    },
    currenciesBlurred() {
      this.currency_focused = false;
      // this.validateField('company_status')
    },
    buyerFocused() {
      this.buyer_focused = true;
    },
    buyerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    sellerFocused() {
      this.buyer_focused = true;
    },
    sellerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    buyer2Focused() {
      this.buyer_focused = true;
    },
    buyer2Blurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    seller2Focused() {
      this.buyer_focused = true;
    },
    seller2Blurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    packingCodeFocused() {
      this.packing_code_focused = true;
    },
    packingCodeBlurred() {
      this.packing_code_focused = false;
    },
    tnvedFocused() {
      this.tnved_focused = true;
    },
    tnvedBlurred() {
      this.tnved_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    measureFocus() {
      this.measure_focused = true;
    },
    measureBlur() {
      this.measure_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    countryFocus() {
      this.country_focused = true;
    },
    countryBlur() {
      this.country_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    deliveryFocused() {
      this.delivery_focused = true;
    },
    deliveryBlurred() {
      this.delivery_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    load() {
      axios
        .get(window.base + "/Document/LoadCMR/?doc_id=" + this.document_id)
        .then((response) => {
          this.$emit("file", response.data.files);
          this.CMR.cmr_number = response.data.cmr_number;
          this.CMR.cmr_date = response.data.cmr_date;
          this.CMR.GoodsCost = response.data.GoodsCost;
          this.CMR.SignatureName = response.data.SignatureName;
          this.CMR.SignatureType = response.data.SignatureType;
          this.CMR.SignDate = response.data.SignDate;
          this.CMR.IsSigned = response.data.IsSigned;
          axios
            .get(
              window.base +
                "/document/getFirmDetails?bin=" +
                response.data.cmr_sender,
            )
            .then((response_) => {
              this.CMR.cmr_sender = {
                value: response.data.cmr_sender,
                display_text: response_.data.org_name,
              };
            });
          // this.findLibValue('company', response.data.cmr_sender , 'CMR', 'cmr_sender')
          // this.CMR.cmr_sender = response.data.cmr_sender
          axios
            .get(
              window.base +
                "/document/getFirmDetails?bin=" +
                response.data.cmr_recipient,
            )
            .then((response_) => {
              this.CMR.cmr_recipient = {
                value: response.data.cmr_recipient,
                display_text: response_.data.org_name,
              };
            });
          // this.findLibValue('company', response.data.cmr_recipient , 'CMR', 'cmr_recipient')
          // this.CMR.cmr_recipient = response.data.cmr_recipient
          axios
            .get(
              window.base +
                "/document/getFirmDetails?bin=" +
                response.data.cmr_courier,
            )
            .then((response_) => {
              this.CMR.cmr_courier = {
                value: response.data.cmr_courier,
                display_text: response_.data.org_name,
              };
            });
          // this.findLibValue('company', response.data.cmr_courier , 'CMR', 'cmr_courier')
          // this.CMR.cmr_courier = response.data.cmr_courier
          axios
            .get(
              window.base +
                "/document/getFirmDetails?bin=" +
                response.data.cmr_courier_next,
            )
            .then((response_) => {
              this.CMR.cmr_courier_next = {
                value: response.data.cmr_courier_next,
                display_text: response_.data.org_name,
              };
            });
          // this.findLibValue('company', response.data.cmr_courier_next , 'CMR', 'cmr_courier_next')
          // this.CMR.cmr_courier_next = response.data.cmr_courier_next

          this.CMR.cmr_track = response.data.cmr_track;
          this.CMR.cmr_trailer = response.data.cmr_trailer;

          this.CMR.cmr_track_reg_country_name = response.data.cmr_track_reg_country_name;

          this.ContractDeliveryTerms.DeliveryPlace =
            response.data.DeliveryPlace;
          this.findDeliveryTerm(response.data.DeliveryTermsStringCode);
          // this.findLibValue('delivery_term', response.data.DeliveryTermsStringCode , 'ContractDeliveryTerms', 'DeliveryTermsStringCode')
          // this.ContractDeliveryTerms.DeliveryTermsStringCode=response.data.DeliveryTermsStringCode
          this.ContractDeliveryTerms.TermsDescription =
            response.data.TermsDescription;

          axios
            .get(
              window.base +
                "/library/customs_office?code=" +
                response.data.custom_code +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((res) => {
              if (res.data[0] != "undefined")
                this.CMR.custom_code = res.data[0];
            });

          this.CMR.courier_notes = response.data.courier_notes;

          //loading_documents
          axios
            .get(
              window.base +
                "/document?attis_contract_id=" +
                this.$route.params.id,
            )
            .then((response) => {
              response.data.forEach((item) => {
                if (item.DocType == "Пакинг лист") {
                  //adding packing list document to the document lists
                  this.CMR_docs.push(item);
                }
                if (item.DocType == "Инвойс") {
                  //adding invoice document to the document lists
                  this.CMR_docs.push(item);
                }
              });
            });

          this.findLibValue(
            "country",
            response.data.CountryCode,
            "TakingCargoPlace",
            "CountryCode",
          );
          // this.TakingCargoPlace.CountryCode=response.data.CountryCode
          this.TakingCargoPlace.City = response.data.City;
          this.TakingCargoPlace.StreetHouse = response.data.StreetHouse.trim();
          this.TakingCargoPlace.PostalCode = response.data.PostalCode.trim();
          this.TakingCargoPlace.TakingCargoDate = response.data.TakingCargoDate;

          this.EnclosedDocument.PrDocumentName = response.data.PrDocumentName;
          this.EnclosedDocument.PrDocumentNumber =
            response.data.PrDocumentNumber;
          this.EnclosedDocument.PrDocumentDate = response.data.PrDocumentDate;

          this.ConsigneeCustoms.WarehouseName = response.data.WarehouseName;

          axios
            .get(
              window.base +
                "/library?type=packaging&query=&qty=100" +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((res) => {
              response.data.product.forEach((good, index) => {
                var packingsList = [];
                res.data.forEach((item) => {
                  if (item.value !== "··········") packingsList.push(item);
                });
                var tmp_good = {
                  good_no: good.good_no,
                  good_guid: good.good_guid,
                  GoodMarking: good.GoodMarking,
                  GoodsDescription: good.GoodsDescription,
                  GoodsQuantity: good.GoodsQuantity,
                  GrossWeightQuantity: good.GrossWeightQuantity,
                  GoodsNomenclatureCode: good.GoodsNomenclatureCode,
                  VolumeQuantity: good.VolumeQuantity,
                  CMRPlaces: [],
                };
                if (_.isArray(good.places) && !_.isEmpty(good.places)) {
                  good.places.forEach((place, ind) => {
                    var packagingType = packingsList.filter((obj) => {
                      return obj.value === place.PackagingTypeCode;
                    });
                    var tmp_place = {
                      PackagingTypeCode: packagingType[0],
                      PlacesCount: place.PlacesCount,
                      Description: place.Description,
                      PlacesPartCount: place.PlacesPartCount,
                    };
                    tmp_good.CMRPlaces.push(tmp_place);
                  });
                } else {
                  tmp_good.CMRPlaces = [];
                }

                this.CMRGoods.push(tmp_good);
                // this.findLibValueProduct('tnved', good.GoodsCode, 'GoodsCode', index)
                // this.findLibValueProduct('country', good.OriginCountryCode, 'OriginCountryCode', index)
                // this.findLibValueProduct('measure', good.SupplementaryQualifierName, 'SupplementaryQualifierName', index)
              });
            });

          if (
            _.isArray(response.data.places) &&
            !_.isEmpty(response.data.places)
          ) {
            response.data.places.forEach((place, index) => {
              axios
                .get(
                  window.base +
                    "/library?type=packaging&query=&qty=100" +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((response) => {
                  var packingsList = [];
                  response.data.forEach((item) => {
                    if (item.value !== "··········") packingsList.push(item);
                  });
                  var packagingType = packingsList.filter((obj) => {
                    return obj.value === place.PackagingTypeCode;
                  });
                  var tmp_place = {
                    PackagingTypeCode: packagingType[0],
                    PlacesCount: place.PlacesCount,
                    Description: place.Description,
                    PlacesPartCount: place.PlacesPartCount,
                  };
                  this.CMRGood.CMRPlaces.push(tmp_place);
                });
            });
          }
        });
    },
    stringifyProducts() {
      var result = [];
      this.CMRGoods.forEach((product, index) => {
        var line = "";
        console.log(product, product.GoodsNomenclatureCode);
        line = "product[" + index + "].GoodMarking=" + product.GoodMarking;
        line +=
          "&product[" +
          index +
          "].GoodsDescription=" +
          product.GoodsDescription;
        line +=
          "&product[" + index + "].GoodsQuantity=" + product.GoodsQuantity;
        line +=
          "&product[" +
          index +
          "].GrossWeightQuantity=" +
          product.GrossWeightQuantity;
        line +=
          "&product[" +
          index +
          "].GoodsNomenclatureCode=" +
          product.GoodsNomenclatureCode;
        line +=
          "&product[" + index + "].VolumeQuantity=" + product.VolumeQuantity;

        // if(typeof product.GoodsCode !=='undefined')
        // 	line += '&product['+index+'].GoodsCode='+product.GoodsCode.value
        // if(typeof product.OriginCountryCode !=='undefined')
        // 	line += '&product['+index+'].OriginCountryCode='+product.OriginCountryCode.value
        // if(typeof product.SupplementaryQualifierName !=='undefined')
        // 	line += '&product['+index+'].SupplementaryQualifierName='+product.SupplementaryQualifierName.value

        result.push(line);
      });
      return result.join("&");
    },
    saveDocument() {
      var data = {
        document: JSON.parse(JSON.stringify(this.document)),
      };
      // this.$v.$touch()
      if (this.$v.CMR.$invalid) {
        this.form_error = true;
        setTimeout(() => {
          if ($(".has-danger").length > 0)
            $("html,body").animate(
              { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
              1000,
            );
        }, 100);
      } else {
        var tmp = JSON.parse(JSON.stringify(this.CMR));

        if (tmp.GoodsCost == "") tmp.GoodsCost = 0;

        this.$root.$emit("show-loading");
        this.buttons_loading = true;
        // tmp.CurrencyCode = tmp.CurrencyCode.value
        if (typeof tmp.cmr_sender !== "undefined")
          tmp.cmr_sender = tmp.cmr_sender.value;
        if (typeof tmp.cmr_recipient !== "undefined")
          tmp.cmr_recipient = tmp.cmr_recipient.value;
        if (typeof tmp.cmr_courier !== "undefined")
          tmp.cmr_courier = tmp.cmr_courier.value;
        if (typeof tmp.cmr_courier_next !== "undefined")
          tmp.cmr_courier_next = tmp.cmr_courier_next.value;
        if (typeof tmp.cmr_track_reg_country_name !== "undefined")
          tmp.cmr_track_reg_country = tmp.cmr_track_reg_country_name.value;

        if (typeof tmp.custom_code !== "undefined")
          tmp.custom_code = tmp.custom_code.value;

        var formData = new FormData();
        for (var i in tmp) {
          formData.append(i, tmp[i]);
        }
        var tmp = JSON.parse(JSON.stringify(this.ContractDeliveryTerms));
        if (typeof tmp.DeliveryTermsStringCode !== "undefined")
          tmp.DeliveryTermsStringCode = tmp.DeliveryTermsStringCode.value;
        for (var i in tmp) {
          formData.append(i, tmp[i]);
        }
        var tmp = JSON.parse(JSON.stringify(this.TakingCargoPlace));
        if (typeof tmp.CountryCode !== "undefined")
          tmp.CountryCode = tmp.CountryCode.value;
        for (var i in tmp) {
          formData.append(i, tmp[i]);
        }
        var tmp = JSON.parse(JSON.stringify(this.EnclosedDocument));
        for (var i in tmp) {
          formData.append(i, tmp[i]);
        }
        var tmp = JSON.parse(JSON.stringify(this.ConsigneeCustoms));
        for (var i in tmp) {
          formData.append(i, tmp[i]);
        }

        formData.append("document_category", "transport");

        let product_is_valid = true;
        this.CMRGoods.forEach((product, index) => {
          if (typeof product.good_no !== "undefined")
            formData.append("product[" + index + "].good_no", product.good_no);
          else formData.append("product[" + index + "].good_no", "");
          if (typeof product.good_guid !== "undefined")
            formData.append(
              "product[" + index + "].good_guid",
              product.good_guid,
            );
          else formData.append("product[" + index + "].good_guid", "");
          if (typeof product.GoodMarking !== "undefined") {
            if (product.GoodMarking !== "") {
              formData.append(
                "product[" + index + "].GoodMarking",
                product.GoodMarking,
              );
            } else {
              product_is_valid = false;
            }
          } else {
            product_is_valid = false;
            formData.append("product[" + index + "].GoodMarking", "");
          }

          if (typeof product.GoodsDescription !== "undefined")
            formData.append(
              "product[" + index + "].GoodsDescription",
              product.GoodsDescription,
            );
          else formData.append("product[" + index + "].GoodsDescription", "");

          if (typeof product.GoodsQuantity !== "undefined")
            formData.append(
              "product[" + index + "].GoodsQuantity",
              product.GoodsQuantity,
            );
          else formData.append("product[" + index + "].GoodsQuantity", "");

          if (typeof product.GrossWeightQuantity !== "undefined")
            formData.append(
              "product[" + index + "].GrossWeightQuantity",
              product.GrossWeightQuantity,
            );
          else
            formData.append("product[" + index + "].GrossWeightQuantity", "");

          if (typeof product.VolumeQuantity !== "undefined")
            formData.append(
              "product[" + index + "].VolumeQuantity",
              product.VolumeQuantity,
            );
          else formData.append("product[" + index + "].VolumeQuantity", "");

          if (typeof product.GoodsNomenclatureCode !== "undefined")
            if (typeof product.GoodsNomenclatureCode == "object") {
              formData.append(
                "product[" + index + "].GoodsNomenclatureCode",
                product.GoodsNomenclatureCode.value,
              );
            } else {
              formData.append(
                "product[" + index + "].GoodsNomenclatureCode",
                product.GoodsNomenclatureCode,
              );
            }
          else
            formData.append("product[" + index + "].GoodsNomenclatureCode", "");

          console.log("savinam places");
          console.log(product.CMRPlaces);
          if (_.isArray(product.CMRPlaces) && !_.isEmpty(product.CMRPlaces)) {
            product.CMRPlaces.forEach((place, ind) => {
              if (typeof place.PlacesCount !== "undefined")
                formData.append(
                  "product[" + index + "].places[" + ind + "].PlacesCount",
                  place.PlacesCount,
                );
              else
                formData.append(
                  "product[" + index + "].places[" + ind + "].PlacesCount",
                  "",
                );

              if (typeof place.Description !== "undefined")
                formData.append(
                  "product[" + index + "].places[" + ind + "].Description",
                  place.Description,
                );
              else
                formData.append(
                  "product[" + index + "].places[" + ind + "].Description",
                  "",
                );
              if (typeof place.PlacesPartCount !== "undefined")
                formData.append(
                  "product[" + index + "].places[" + ind + "].PlacesPartCount",
                  place.PlacesPartCount,
                );
              else
                formData.append(
                  "product[" + index + "].places[" + ind + "].PlacesPartCount",
                  "",
                );

              if (typeof place.PackagingTypeCode !== "undefined")
                formData.append(
                  "product[" +
                    index +
                    "].places[" +
                    ind +
                    "].PackagingTypeCode",
                  place.PackagingTypeCode.value,
                );
              else
                formData.append(
                  "product[" +
                    index +
                    "].places[" +
                    ind +
                    "].PackagingTypeCode",
                  "",
                );
            });
          }
        });

        if (!product_is_valid) {
          this.products_marking_error = true;
          return;
        } else {
          this.products_marking_error = false;
        }
        // Attach file
        formData.append("file", data.document.file);
        if (data.document.attis_contract_doc_type) {
          data.document.attis_contract_doc_type = data.document.attis_contract_doc_type.value;
        }
        var t1 = this.$t("message.error");
        axios
          .post(
            window.base +
              (this.document_id == "new"
                ? "/Document/CreateCMR" +
                  "?attis_contract_id=" +
                  this.$route.params.id
                : "/Document/UpdateCMR" +
                  "?attis_contract_id=" +
                  this.document_id),
            /*querystring.stringify(tmp)+'&'+this.stringifyProducts()+querystring.stringify(data.document)+'&document_id='+this.document_id+'&document_category=finance', */ formData,
            { headers: { "Content-Type": "multipart/form-data" } },
          )
          .then((response) => {
            if (response.data.trim() == "ok") {
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.cmr-created"),
                timeout: 5000,
              }).show();
              this.$root.$emit("loadDocuments", { category: "all" });
              this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
              this.$root.$emit(
                "bv::hide::modal",
                "modal-document-new",
                "#btnShow",
              );
              this.buttons_loading = false;
            } else {
              new Noty({
                theme: "light",
                type: "error",
                text:
                  this.$root.$t("message.message.cmr-not-created") +
                  " (" +
                  response.data +
                  ")",
                timeout: 5000,
              }).show();
              if (window.dev_mode) {
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
              this.buttons_loading = false;
            }
          })
          .catch((e) => {
            // console.log("checkinam1");
            console.log(e);
            // console.log(response.data);
            new Noty({
              theme: "light",
              type: "error",
              text: t1,
              timeout: 5000,
            }).show();
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
            this.buttons_loading = false;
          });
        // console.log(tmp, data.document, this.stringifyProducts())
        // axios.post(window.base+(this.document_id=='new'?'/Document/Create':'/Document/Update')+'?attis_contract_id='+this.$route.params.id, querystring.stringify(tmp)+'&'+this.stringifyProducts()+querystring.stringify(data.document)+'&document_id='+this.document_id+'&document_category=finance')
      }
    },
    findLibValue(lib, value, object, field) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (
                item.value.trim().toLowerCase() == value.trim().toLowerCase()
              ) {
                this.$set(this.$data[object], field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value.trim().toLowerCase() == value.trim().toLowerCase())
            this.$set(this.$data[object], field, item);
        });
      }
    },
    importGoodsExcel(event, index) {
      if (typeof event.target.files[0] !== "undefined") {
        var fd = new FormData();
        this.files_loading = true;
        fd.append("Files[0]", event.target.files[0]);
        axios
          .post(window.base + "/document/import_excel_goods?type=cmr", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.files_loading = false;
            if (response.data !== "error") {
              response.data.forEach((good) => {
                var tmp_good = {};
                //tmp_good.good_guid = good.cgood_guid
                tmp_good = good;
                (tmp_good.good_guid = this.CMRGoods.length + 1),
                  this.CMRGoods.push(tmp_good);
              });
            }
            //this.hideAddProduct();
          });
      }
    },
  },
  mounted() {
    this.fetchCurrencies();
    this.fetchContragents("");
    this.fetchTNVED("");
    this.fetchMeasures("");
    this.fetchCountries("");
    this.fetchDeliveryTerms("");
    this.fetchPackagings("");
    this.fetchCustomCode("");

    if (this.document_id == "new") {
      var date = new Date();
      this.CMR.cmr_number =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
        "-" +
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1);
      // this.Invoice.CurrencyCode = this.contract_details.attis_contract_currency
      /*if(typeof this.goods !== 'undefined')
					this.goods.forEach(good=>{
						var tmp_good = {}
						tmp_good.GoodsNomenclatureCode = good.attis_cg_TNVED
						tmp_good.GoodsDescription = good.attis_cg_good_name
						tmp_good.GoodsQuantity = good.attis_cg_quantity
						// tmp_good.SupplementaryQualifierName = good.attis_cg_measures
						// tmp_good.Price = good.attis_cg_price

						this.CMRGoods.push(tmp_good)
					})*/
      //do load invoice data
      this.ContractDeliveryTerms.DeliveryPlace =
        this.contract_details.attis_contract_delivery_place;
      // this.ContractDeliveryTerms.DeliveryTermsStringCode = this.contract_details.attis_contract_delivery_term
      if (
        typeof this.contract_details.attis_contract_delivery_term === "object"
      ) {
        this.ContractDeliveryTerms.DeliveryTermsStringCode =
          this.contract_details.attis_contract_delivery_term;
      } else {
        this.findLibValue(
          "delivery_term",
          this.contract_details.attis_contract_delivery_term,
          "ContractDeliveryTerms",
          "DeliveryTermsStringCode",
        );
      }

      //loading_documents
      axios
        .get(
          window.base + "/document?attis_contract_id=" + this.$route.params.id,
        )
        .then((response) => {
          response.data.forEach((item) => {
            if (item.DocType == "Пакинг лист") {
              //adding packing list document to the document lists
              this.CMR_docs.push(item);
            }
            if (item.DocType == "Инвойс") {
              //adding invoice document to the document lists
              this.CMR_docs.push(item);

              axios
                .get(
                  window.base +
                    "/Document/LoadInvoice/?doc_id=" +
                    item.DocumentID,
                )
                .then((response) => {
                  this.CMR.GoodsCost = response.data.GCost;
                  //loading products
                  response.data.product.forEach((good) => {
                    var tmp_good = {};
                    // tmp_good.GoodsNomenclatureCode = good.GoodsCode
                    this.findTNVED(good.GoodsCode.trim(), this.CMRGoods.length);
                    // this.findLibValueProduct('tnved', good.GoodsCode.trim(), 'GoodsNomenclatureCode', this.CMRGoods.length)
                    tmp_good.good_no = good.good_no;
                    tmp_good.good_guid = good.good_guid;
                    tmp_good.GoodsDescription = good.GoodsDescription;
                    tmp_good.GoodsQuantity = good.GoodsQuantity;
                    tmp_good.GoodMarking = good.GoodMarking;
                    tmp_good.GrossWeightQuantity = good.GrossWeightQuantity;
                    // tmp_good.SupplementaryQualifierName = good.attis_cg_measures
                    // tmp_good.Price = good.attis_cg_price

                    this.CMRGoods.push(tmp_good);
                  });
                  // this.CMR.cmr_sender = response.data.InvoiceSeller
                  // this.CMR.cmr_recipient = response.data.InvoiceByer
                  axios
                    .get(
                      window.base +
                        "/document/getFirmDetails?bin=" +
                        response.data.InvoiceByer,
                    )
                    .then((response_) => {
                      this.CMR.cmr_recipient = {
                        value: response.data.InvoiceByer,
                        display_text: response_.data.org_name,
                      };
                    });
                  axios
                    .get(
                      window.base +
                        "/document/getFirmDetails?bin=" +
                        response.data.InvoiceSeller,
                    )
                    .then((response_) => {
                      this.CMR.cmr_sender = {
                        value: response.data.InvoiceSeller,
                        display_text: response_.data.org_name,
                      };
                    });
                  // this.findLibValue('company', response.data.InvoiceSeller, 'CMR', 'cmr_sender')
                  // this.findLibValue('company', response.data.InvoiceByer, 'CMR', 'cmr_recipient')
                });
            }
          });
        });
      //load selected courier
      setTimeout(() => {
        axios
          .get(
            window.base +
              "/contract/selectedCourierOffer?contract_id=" +
              this.$route.params.id,
          )
          .then((response) => {
            if (response.data.org_code !== null) {
              this.CMR.cmr_courier = {
                value: response.data.org_code,
                display_text: response.data.org_name,
              };
            }
          });
      }, 2000);
    } else {
      this.load();
    }

    this.$root.$on("saveDocument", (data) => {
      if (typeof data.document.attis_contract_doc_type === "object") {
        if (data.document.attis_contract_doc_type.value == "cmr") {
          this.saveDocument(data);
        }
      } else {
        if (data.document.attis_contract_doc_type == "cmr") {
          this.saveDocument(data);
        }
      }
    });
    this.$root.$on("set.sender.contragent", (data) => {
      this.CMR.cmr_sender = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
    this.$root.$on("set.recipient.contragent", (data) => {
      this.CMR.cmr_recipient = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
    this.$root.$on("set.courier.contragent", (data) => {
      this.CMR.cmr_courier = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
    this.$root.$on("set.courier_next.contragent", (data) => {
      console.log(data);
      this.CMR.cmr_courier_next = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
    is_field_readonly() {
      if (this.CMR.IsSigned) return true;
      return false;
    },
  },
  watch: {},
  validations: {
    CMR: {
      cmr_number: {
        required,
      },
      cmr_date: {
        required,
      },
      cmr_sender: {
        value: { required },
      },
      custom_code: {
        value: { required },
      },
      cmr_recipient: {
        value: { required },
      },
      cmr_track: {
        required,
      },
      cmr_trailer: {
        required,
      },
    },
    ContractDeliveryTerms: {
      DeliveryPlace: { required },
      DeliveryTermsStringCode: { value: { required } },
    },
    TakingCargoPlace: {
      CountryCode: {
        value: { required },
      },
      City: {
        required,
      },
      TakingCargoDate: {
        required,
      },
    },
    CMRGood: {
      GoodsDescription: {
        required,
      },
      GoodMarking: {
        required,
      },
    },
  },
};
</script>
<style>
.add-product-block {
  background: rgba(23, 198, 113, 0.2) !important;
  margin: 0px -2.2rem !important;
  padding: 2.2rem !important;
}
</style>
